import React, { FunctionComponent, useState, useEffect } from "react"
import styled from 'styled-components'

import Aside from '@components/aside'
import Loader from '@components/loader'

interface LayoutProps {
  title: string
  children: React.ReactNode
}

const Layout: FunctionComponent<LayoutProps> = ({ children, title }) => {
  const path = () => typeof window === 'object' ? window.location.pathname : null
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = path() === rootPath

  const [showLoader, setShowLoader] = useState(true)
  const [showBg, setShowBg] = useState(false)

  useEffect(() => {
    setShowLoader(false)
  }, [])

  return (
    <Wrapper
      className="page-wrapper"
      // data-is-root-path={isRootPath}
    >
      <Aside />

      <main>{children}</main>

      {/* <footer>
        © {new Date().getFullYear()}, Built with
        {` `}
        <a href="https://www.gatsbyjs.com">Gatsby</a>
      </footer> */}

      <Loader className={showLoader ? 'show fullscreen' : 'fullscreen'} />
      <BackgroundWrapper>
        <Background
          // src="https://images.unsplash.com/photo-1489549132488-d00b7eee80f1"
          src="/media/bg2.jpg"
          alt="bg"
          style={{
            opacity: showBg && !showLoader ? 1 : 0,
          }}
          onLoad={() => setShowBg(true)}
        ></Background>
      </BackgroundWrapper>
    </Wrapper>
  )
}

export default Layout

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`
const BackgroundWrapper = styled.div`
  background-color: #171d37;
  transition: all 1s ease;
  transition-delay: 0.5s;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
`;
const Background = styled.img`
  position: fixed;
  object-fit: cover;
  object-position: center;
  opacity: 0;
  transition: opacity 0.5s;
  z-index: -1;
  bottom: 0;
  right: 0;
`
